import React from "react";

const Hierarchy = () => {
  return <div>Hierarchy</div>;
};

export default Hierarchy;
